export function getPaginationItems({
  currentPage,
  totalPages,
  siblingCount = 1,
  boundaryCount = 1,
}: {
  currentPage: number;
  totalPages: number;
  siblingCount?: number;
  boundaryCount?: number;
}): (number | 'LEFT_ELLIPSIS' | 'RIGHT_ELLIPSIS')[] {
  if (totalPages <= 0) return [];
  if (totalPages === 1) return [1];

  const items: (number | 'LEFT_ELLIPSIS' | 'RIGHT_ELLIPSIS')[] = [];

  for (let i = 1; i <= Math.min(boundaryCount, totalPages); i++) {
    items.push(i);
  }

  const leftSibling = Math.max(currentPage - siblingCount, boundaryCount + 1);
  const rightSibling = Math.min(
    currentPage + siblingCount,
    totalPages - boundaryCount
  );

  const leftGap = leftSibling - (boundaryCount + 1);
  const rightGap = totalPages - boundaryCount - rightSibling;

  if (leftGap > 0) {
    if (leftGap === 1) {
      items.push(boundaryCount + 1);
    } else if (leftGap > 1) {
      items.push('LEFT_ELLIPSIS');
    }
  }

  for (let i = leftSibling; i <= rightSibling; i++) {
    if (i > boundaryCount && i <= totalPages - boundaryCount) {
      items.push(i);
    }
  }

  if (rightGap > 0) {
    if (rightGap === 1) {
      items.push(totalPages - boundaryCount);
    } else if (rightGap > 1) {
      items.push('RIGHT_ELLIPSIS');
    }
  }

  for (
    let i = Math.max(totalPages - boundaryCount + 1, boundaryCount + 1);
    i <= totalPages;
    i++
  ) {
    if (!items.includes(i)) {
      items.push(i);
    }
  }

  return items;
}
